import React from 'react';
import UserContext from '../contexts/UserContext';
import get from 'lodash/get';

export default function useIsAllowed(props) {
  const { allowedGroups = [], disallowedGroups } = props;
  const { currentUser } = React.useContext(UserContext);
  const userGroup = get(currentUser, 'memberInfo.role.group');
  let allowed = allowedGroups.includes(userGroup);
  if (disallowedGroups) {
    allowed = !disallowedGroups.includes(userGroup);
  }

  return allowed;
}
